/**
 * KPI Cards Mock Data
 * Contains dummy data for dashboard KPI metrics
 * This data will be replaced with real API responses when backend is ready
 */

const KPI_CARDS_MOCK_DATA = [
  {
    value: '34M',
    label: 'License Cost',
    trend: {
      value: '+21%',
      direction: 'up' as const,
      period: 'YoY',
    },
  },
  {
    value: '16K',
    label: 'Active Licenses',
    trend: {
      value: '+15',
      direction: 'down' as const,
      period: 'MoM',
    },
  },
  {
    value: '78%',
    label: 'License Utilization',
    trend: {
      value: '+5%',
      direction: 'up' as const,
      period: 'MoM',
    },
  },
  {
    value: '3M',
    label: 'Cost Savings Potential',
    riskInfo: 'YoY Savings',
  },
  {
    value: '7',
    label: 'Risk Alerts',
    riskInfo: [
      { text: '2 Critical', color: 'critical' as const },
      { text: ', 1 Medium', color: 'medium' as const },
    ],
  },
];

export default KPI_CARDS_MOCK_DATA;
